// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"21197660","150":"20c7dc65","195":"4526e1e0","477":"65b1a635","547":"f7c417e2","615":"6693e75a","658":"755b5adb","752":"0bf1d55c"}[chunkId] + ".chunk.js";
};